// extracted by mini-css-extract-plugin
export var colorSquare = "_t8-0";
export var danger = "_t8-5";
export var lightPink = "_t8-8";
export var neutralBlue = "_t8-7";
export var neutralYellow = "_t8-6";
export var normal = "_t8-1";
export var primary = "_t8-2";
export var primaryLight = "_t8-3";
export var solidBlack = "_t8-g";
export var solidGreen = "_t8-b";
export var solidLightBlue = "_t8-d";
export var solidNavy = "_t8-c";
export var solidOrange = "_t8-f";
export var solidPink = "_t8-e";
export var solidRed = "_t8-9";
export var solidYellow = "_t8-a";
export var success = "_t8-4";